import type {
  IBillingHistory,
  ICancelSubscriptionPayload,
  ISavedPaymentMethod,
  ISavePaymentMethodResponse,
  ISubscription,
  ISubscriptionBalanceResponse,
  ISubscriptionCheckoutPayload,
  ISubscriptionCheckoutResponse,
  IUpcomingPayment,
} from "../types/subscription";
import type { ApiClient } from "./client";

export class SubscriptionApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getBalance(): Promise<ISubscriptionBalanceResponse> {
    const response = await this.apiClient.get<ISubscriptionBalanceResponse>(
      "/subscription/balance",
    );
    return response.data;
  }

  async getSubscriptionsList(): Promise<ISubscription[]> {
    const response =
      await this.apiClient.get<ISubscription[]>("/subscription/list");
    return response.data;
  }

  async getBillingHistory(): Promise<IBillingHistory[]> {
    const response = await this.apiClient.get<IBillingHistory[]>(
      "/subscription/billing",
    );
    return response.data;
  }

  async getUpcomingPayment(): Promise<IUpcomingPayment | null> {
    const response = await this.apiClient.get<IUpcomingPayment | null>(
      "/subscription/upcoming-payment",
    );
    return response.data;
  }

  async initiateSubscription(
    data: ISubscriptionCheckoutPayload,
  ): Promise<ISubscriptionCheckoutResponse> {
    const response = await this.apiClient.post<ISubscriptionCheckoutResponse>(
      "/subscription/initiate",
      data,
    );
    return response.data;
  }

  async changeSubscription(
    data: ISubscriptionCheckoutPayload,
  ): Promise<ISubscriptionCheckoutResponse> {
    const response = await this.apiClient.post<ISubscriptionCheckoutResponse>(
      "/subscription/change",
      data,
    );
    return response.data;
  }

  async cancelSubscription(data: ICancelSubscriptionPayload): Promise<void> {
    await this.apiClient.post("/subscription/cancel", data);
  }

  async getSavedPaymentMethods(): Promise<ISavedPaymentMethod[]> {
    const response = await this.apiClient.get<{
      data: ISavedPaymentMethod[];
    }>("/subscription/saved-payment-methods");
    return response.data.data;
  }

  async savePaymentMethod(): Promise<ISavePaymentMethodResponse> {
    const response = await this.apiClient.post<ISavePaymentMethodResponse>(
      "/subscription/save-payment-method",
    );
    return response.data;
  }

  async toggleDefaultPaymentMethod(paymentMethodId: string): Promise<void> {
    await this.apiClient.post("/subscription/toggle-default-payment-method", {
      paymentMethodId,
    });
  }

  async deletePaymentMethod(paymentMethodId: string): Promise<void> {
    await this.apiClient.post("/subscription/delete-payment-method", {
      paymentMethodId,
    });
  }
}
